const _hostname = window.location.hostname;
let base = '//api-bjnews.iuxiao.com/api/v101'
let host = "http://cms-bjnews.iuxiao.com/h5"
if (_hostname === 'cdn.bjnews.com.cn' || _hostname === '192.168.0.11') {  //正式环境
  base = '//api.bjnews.com.cn/api/v101'
  host = "//cdn.bjnews.com.cn/h5"
} else if (_hostname === 'cms-bjnews.iuxiao.com' || _hostname === '192.168.21.176') {   //测试环境
  // base = '//api-bjnews.iuxiao.com/api/v101'
  base = 'http://api-bjnews.iuxiao.com/api/v101/'
  host = "http://cms-bjnews.iuxiao.com/h5"
} else if(_hostname === 'dev-cms-bjnews.iuxiao.com' || _hostname === 'localhost'){ // 开发环境
  // base = '//api-bjnews.iuxiao.com/api/v101'
  // base = 'http://dev-api-bjnews.iuxiao.com/api/v101/'
  base = '//api.bjnews.com.cn/api/v101'
  host = "http://cms-bjnews.iuxiao.com/h5"
}

var API = {
  base: base,
  host: host,
  map_icon: host + "/resource/map_icon.png",
  anuscript_detail: base + '/news/manuscript_detail.php',
  special_detail: base + '/news/special_detail.php',
  graph_article_detail: base + '/news/graph_article_detail.php',
  video_detail: base + '/news/video_detail.php',
  pv: base + '/census/pv.php',
  live_group : base + '/news/live_group_text.php', // 图文直播
  comment_list : base + '/news/comment_list.php', // 评论列表
  reply_list : base + '/news/reply_list.php', //获取评论回复
  share_logo : base + '/other/share_watermark.php' , //获取分享LOGO

  // 新京号话题
  xjh_topic_info : base + '/xjh/topic_info.php' , //新京号话题详情
  xjh_topic_articleList : base + '/xjh/topic_article.php' , //新京号话题文章列表
  xjh_list : base + '/xjh/xjh_list.php' , //新京号列表

  share_title: '新京报',
  share_des: '好新闻 无止境',
  share_img: 'https://cdn.bjnews.com.cn/h5/icon.png',
  appid: 'wx4d8c625e1dbcf8f4',
}

export default API;

// 普通专题分享页:
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/subject/1/专题uuid
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/subject/1/153914868011238
// 时间轴专题分享页
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/subject/2/专题uuid
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/subject/2/153907744811213
// 图文详情页
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/detail/1/详情uuid
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/detail/1/153914824111237
// 普通视频详情页
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/detail/2/详情uuid/2
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/detail/2/153905474211138/2
// 直播详情页
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/detail/2/详情uuid/6
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/detail/2/153939794111313/6
// 图说详情页
//     格式http://cms-bjnews.iuxiao.com/h5/index.html#/detail/3/详情uuid
//     例子http://cms-bjnews.iuxiao.com/h5/index.html#/detail/3/153941330111338


// WEBPACK FOOTER //
// ./src/config/api.js